export default __webpack_public_path__ + "static/media/Beach vibes_primary.ee265f76.jpg";